import { HTMLInputTypeAttribute } from "react";
import GooglePlacesAutocomplete from "react-google-places-autocomplete";

interface Props {
  label?: string;
  value?: any;
  onChange?: any;
  type?: HTMLInputTypeAttribute | undefined;
  inputClassName?: string;
  labelClassName?: string;
  placeholder?: string;
  error?: boolean;
}

export const AutocompleteInput = ({
  label,
  value,
  onChange,
  type,
  inputClassName,
  labelClassName,
  placeholder,
  error,
  ...rest
}: Props) => {
  return (
    <div className="mb-4">
      <p
        className={`font-satoshi text-dark text-sm font-medium mb-3 ${labelClassName}`}
      >
        {label}
      </p>
      <GooglePlacesAutocomplete
        selectProps={{
          value,
          onChange,
          styles: {
            input: (provided) => {
              return {
                ...provided,
                color: "#202325",
                "::placeholder": {
                  color: "#202325",
                },
                fontFamily: "Satoshi",
                outline: "none",
                "outline:focus": "none",
                "focus:outline": "none",
              };
            },
            control: (provided, state) => ({
              ...provided,
              width: "100%",
              height: "46px",
              backgroundColor: "#edf2f7", // Use your preferred colors
              borderColor: state.isFocused ? "#718096" : "#cbd5e0", // Adjust focus border color
              borderRadius: "0.375rem",
              borderWidth: "1px",
              boxShadow: state.isFocused
                ? "0 0 0 2px rgba(66, 153, 225, 0.5)"
                : "none", // Adjust focus box shadow
              outline: "none",
              fontSize: "1rem",
              fontWeight: "500",
              color: "#2d3748",
              transition: "border-color 0.3s, box-shadow 0.3s", // Transition for focus effects
            }),
          },
        }}
        apiKey={process.env.REACT_APP_GOOGLE_API}
      />
    </div>
  );
};
